/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { S as Scrim, d as defineCustomElement$1 } from './scrim.js';

const CalciteScrim = Scrim;
const defineCustomElement = defineCustomElement$1;

export { CalciteScrim, defineCustomElement };

//# sourceMappingURL=calcite-scrim.js.map